<template>
    <SOSlotBase
        :is-search="isSearch"
        :bg-grey="!pageSetting.loading.export"
        :bg-white="pageSetting.loading.export"
        :container-name="pageSetting.containerName"
    >
        <template v-slot:title-bar>
            <SOTitleBar
                :page-title="pageSetting.pageTitle"
                :type="'back'"
                :show-search="!pageSetting.loading.list"
                @search="search"
                @back="back"
                v-if="!isSearch && !pageSetting.loading.export"
            />
        </template>

        <template v-slot:search-bar>
            <SOSearchBar
                v-if="isSearch && !pageSetting.loading.export"
                :context="'Permintaan Kas Outlet'"
                :value="searchKey.key"
                :data-count="permintaanOutlet.data.length"
                :waiting="pageSetting.search.waiting"
                :search-information="'Nama outlet, Nominal, Dari akun, Waktu dibuat & Nama pembuat'"
                @return-search-value="
                    (v) => {
                        searchKey.key = v;
                    }
                "
                @loading="loadingSearch"
                @do-search="searchPermintaan"
                @close="closeSearch"
            />
        </template>

        <template v-slot:empty-state>
            <SOEmptyState
                v-if="permintaanOutlet.data.length === 0 && !isSearch && !pageSetting.loading.list"
                :message="'Belum ada permintaan kas'"
                :sub-message="'Klik tombol + untuk menambahkan, atau bisa juga melalui aplikasi kasir.'"
            />
            <SOEmptySearchState
                v-if="
                    isSearch &&
                        !pageSetting.loading.list &&
                        !pageSetting.search.waiting &&
                        permintaanOutlet.data.length === 0 &&
                        searchKey.key.length > 1
                "
                @action="
                    () => {
                        resetFilter();
                        searchKey.key = '';
                    }
                "
            />
        </template>

        <template v-slot:skeleton>
            <div class="p-x-20 p-y-16 w-limit" v-if="pageSetting.loading.list">
                <SOCardTransaksiSkeleton v-if="!isSearch" />
                <SOLoadSearch v-if="isSearch" />
            </div>
        </template>

        <template v-slot:content v-if="!pageSetting.loading.export">
            <SOExportProgressMinimized
                v-if="pageSetting.minimizedExport"
                :processed-data="exportProgress.processed"
                :total-data="exportProgress.total"
                :context="''"
                :tracker-actions="''"
                @on-success="checkExport"
                @on-error="
                    () => {
                        pageSetting.minimizedExport = false;
                    }
                "
            />
            <SOExportMultipleFile
                v-if="pageSetting.multipleExport && !pageSetting.minimizedExport"
                :export-data="exportData"
                :export-data-length="exportDataLength"
                :delete-cluster-actions="''"
                :delete-master-actions="''"
                @downloaded="
                    (index) => {
                        exportData[index].downloaded = true;
                    }
                "
                @done="
                    () => {
                        pageSetting.multipleExport = false;
                        exportData = [];
                    }
                "
            />

            <div class="p-x-20 p-t-16 w-limit" v-if="!pageSetting.loading.list">
                <SOHeaderList
                    :title="
                        isSearch
                            ? permintaanOutlet.data.length > 0
                                ? permintaanOutlet.data.length + ' Permintaan'
                                : ''
                            : permintaanOutlet.data.length + ' Permintaan'
                    "
                    :show-filter="true"
                    @filter="
                        () => {
                            pageSetting.showFilter = true;
                        }
                    "
                />
                <div v-if="!pageSetting.loading.list">
                    <div
                        v-for="(permintaan, i) in permintaanOutlet.data.main_data"
                        :key="i"
                        @click="detail(permintaan.idtransfer, $event)"
                        class="p-d-12"
                    >
                        <CardPermintaanKasOutlet :permintaan="permintaan" :search="searchKey.key" />
                    </div>
                </div>

                <SOLoadMoreLoading
                    v-if="permintaanOutlet.data.length > 0"
                    :id="pageSetting.loadMoreLoadingId"
                    :loading="pageSetting.loading.loadMore"
                />
            </div>
            <!--<SOFABExport-->
            <!--	v-if="true"-->
            <!--	@export="() => { pageSetting.modal.export = true }"-->
            <!--/>-->
            <SOFABRegular
                v-if="!pageSetting.loading.list && validateAccess('cashRequestOutlet.create')"
                @add="
                    () => {
                        $router.push({ name: 'PermintaanKasOutlet.Create' });
                        smartTrackingClick('add_permintaan_outlet');

            }
                "
            />
        </template>

        <template v-slot:filter>
            <SOFilter
                v-if="pageSetting.showFilter"
                :filter-permintaan-kas-outlet="pageSetting.showFilter"
                :sorting="sorting"
                @back="
                    () => {
                        pageSetting.showFilter = false;
                    }
                "
                @do-filter="doFilter"
                @reset-filter="resetFilter"
            />
        </template>

        <template v-slot:modal>
            <SOModalExport
                v-if="pageSetting.modal.export"
                :is-running="pageSetting.minimizedExport"
                :context="''"
                :total-data="permintaanOutlet.data.length + ' Permintaan'"
                :export-data-exist="exportData.length > 0 ? exportData.filter((v) => v.downloaded === false).length : 0"
                @close="
                    () => {
                        pageSetting.modal.export = false;
                    }
                "
                @do-export="doExport"
            />
        </template>

        <template v-slot:export-import>
            <SOExportProgress
                v-if="pageSetting.loading.export"
                :context="''"
                :tracker-actions="''"
                @on-success="checkExport"
                @on-error="
                    () => {
                        pageSetting.loading.export = false;
                    }
                "
                @minimized-export="minimizedExport"
            />
        </template>
    </SOSlotBase>
</template>

<script>
import { mapGetters } from "vuex";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import SOCardTransaksiSkeleton from "@/so-components/modules/transaksi/reguler/SOCardTransaksiSkeleton";
import SOLoadSearch from "@/so-components/global/ui/SOLoadSearch";
import SOExportProgressMinimized from "@/so-components/global/ui/SOExportProgressMinimized";
import SOExportMultipleFile from "@/so-components/global/ui/SOExportMultipleFile";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import CardPermintaanKasOutlet from "@/modules/permintaan-kas/outlet/views/components/CardPermintaanKasOutlet";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOFABExport from "@/so-components/global/ui/SOFABExport";
import SOFABRegular from "@/so-components/global/ui/SOFABRegular";
import SOFilter from "@/so-components/global/filter/base/SOFilter";
import SOModalExport from "@/so-components/global/modal/SOModalExport";
import SOExportProgress from "@/so-components/global/ui/SOExportProgress";

export default {
    name: "PermintaanKasOutlet",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOSearchBar,
        SOEmptyState,
        SOEmptySearchState,
        SOCardTransaksiSkeleton,
        SOLoadSearch,
        SOExportProgressMinimized,
        SOExportMultipleFile,
        SOHeaderList,
        CardPermintaanKasOutlet,
        SOLoadMoreLoading,
        SOFABExport,
        SOFABRegular,
        SOFilter,
        SOModalExport,
        SOExportProgress,
    },
    computed: {
        ...mapGetters("permintaanKasOutletModule", {
            permintaanOutlet: "getPermintaanKasOutletList",
            pagination: "getPagination",
            searchKey: "getSearch",
            isSearch: "getIsSearch",
            scrollPosition: "getScrollPosition",
        }),
        ...mapGetters("filterGlobalModule", {
            filter: "getFilter",
            filterItem: "getFilterItem",
        }),
    },
    data() {
        return {
            pageSetting: {
                pageTitle: "Permintaan Kas Outlet",
                containerName: "list-permintaan-kas-outlet-content",
                loadMoreLoadingId: "loading-list-permintaan-kas-outlet-content",
                loading: {
                    list: false,
                    loadMore: false,
                    search: {
                        waiting: false,
                    },
                    export: false,
                },
                search: {
                    waiting: false,
                },
                modal: {
                    export: false,
                },
                showFilter: false,
                minimizedExport: false,
                multipleExport: false,
                error: {
                    list: null,
                },
            },
            exportProgress: {
                processed: 0,
                total: 0,
            },
            exportData: [],
            exportDataLength: 0,

            sorting: [
                {
                    label: "Belum dikonfirmasi",
                    name: "sorting",
                    value: JSON.stringify({
                        sortBy: "status",
                        orderBy: "ASC",
                    }),
                    id: "sorting-1",
                },
                {
                    label: "Sudah dikonfirmasi",
                    name: "sorting",
                    value: JSON.stringify({
                        sortBy: "status",
                        orderBy: "DESC",
                    }),
                    id: "sorting-2",
                },
                {
                    label: "Permintaan terbaru",
                    name: "sorting",
                    value: JSON.stringify({
                        sortBy: "waktu",
                        orderBy: "DESC",
                    }),
                    id: "sorting-3",
                },
                {
                    label: "Permintaan terlama",
                    name: "sorting",
                    value: JSON.stringify({
                        sortBy: "waktu",
                        orderBy: "ASC",
                    }),
                    id: "sorting-4",
                },
                {
                    label: "Nominal terkecil",
                    name: "sorting",
                    value: JSON.stringify({
                        sortBy: "nominal",
                        orderBy: "ASC",
                    }),
                    id: "sorting-5",
                },
                {
                    label: "Nominal terbesar",
                    name: "sorting",
                    value: JSON.stringify({
                        sortBy: "nominal",
                        orderBy: "DESC",
                    }),
                    id: "sorting-6",
                },
            ],
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            let query = vm.$route.query;
            if (from.path.split("/")[1] !== "permintaan-kas-outlet") {
                vm.initPermintaanKasOutlet(query);
            } else {
                if (vm.permintaanOutlet.data === undefined) {
                    vm.initPermintaanKasOutlet(query);
                    return;
                }
                vm.setScrollPosition();
            }
        });
    },
    mounted() {
        this.scroll();
        this.smartTrackingView("permintaan_outlet");

    },
    methods: {
        back() {
            this.$router.push("/dashboard");
        },
        async initPermintaanKasOutlet(query) {
            await this.flushData();

            await this.setDefaultFilter(query);
            await this.listPermintaanOutlet();
        },
        async setDefaultFilter(query) {
            // let query = this.$route.query
            let filterItem = this.filterItem;
            await this.$store.commit("filterGlobalModule/resetFilterItem");
            if (Object.keys(query).length > 0) {
                if (query.filter_by) filterItem.periode.filterBy = query.filter_by;
                if (query.tanggal_awal) filterItem.periode.startDate = query.tanggal_awal;
                if (query.tanggal_akhir) filterItem.periode.endDate = query.tanggal_akhir;
                if (query.bulan) filterItem.periode.month = query.bulan;
                if (query.tahun) filterItem.periode.year = query.tahun;
                if (query.idkaryawan) filterItem.karyawan = query.idkaryawan;
                if (query.akun_tujuan)
                    filterItem.akunKeuanganGlobal = Array.isArray(query.akun_tujuan)
                        ? query.akun_tujuan
                        : [query.akun_tujuan];
                if (query.status)
                    filterItem.statusKonfirmasi = Array.isArray(query.status) ? query.status : [query.status];
                if (query.idoutlet)
                    filterItem.outlet = Array.isArray(query.idoutlet) ? query.idoutlet : [query.idoutlet];

                await this.$store.commit("filterGlobalModule/setFilterItem", filterItem);

                if (query.key) {
                    await this.$store.commit("permintaanKasOutletModule/setSearch", query.key);
                    await this.$store.commit("permintaanKasOutletModule/setIsSearch", true);
                }

                let temp = this.filter;
                temp.sortBy = query.sort_by;
                temp.orderBy = query.order_by;
                await this.$store.commit("filterGlobalModule/setFilter", temp);
            } else {
                await this.resetFilter();
                filterItem.periode = {
                    endDate: "",
                    filterBy: "bulan",
                    startDate: "",
                    month: this.$moment().format("YYYY-MM"),
                    year: "",
                };
                await this.$store.commit("filterGlobalModule/setFilterItem", filterItem);
            }

            await this.$store.commit("permintaanKasOutletModule/resetPagination");
        },
        async listPermintaanOutlet() {
            if (!this.pageSetting.loading.list) {
                this.pageSetting.loading.loadMore = true;
            }
            if (this.permintaanOutlet.data !== undefined) {
                this.pageSetting.search.waiting = true;
            }
            const res = await this.$store.dispatch("permintaanKasOutletModule/fetchPermintaanKasOutletList");
            this.pageSetting.loading.list = false;
            this.pageSetting.loading.loadMore = false;
            this.pageSetting.search.waiting = false;
            this.$store.commit("helper/setScrollCalled", false);
            if (res.success) {
                this.pageSetting.error.list = false;
                await this.$store.commit("permintaanKasOutletModule/setNextPagination", {
                    data: this.permintaanOutlet.data,
                });
            } else {
                this.pageSetting.error.list = true;
                setTimeout(() => {
                    this.pageSetting.error.list = false;
                }, 10000);
                this.$toast.error(res.err);
            }
        },
        detail(id, event) {
            this.$store.commit("permintaanKasOutletModule/setScrollPosition", event.pageY);
            this.$router.push({ name: "PermintaanKasOutlet.Detail", params: { id: id } });
            this.smartTrackingClick("detail_permintaan_outlet");

        },

        // scroll
        scroll() {
            window.onscroll = async () => {
                if (this.pageSetting.error.list) {
                    return;
                }
                let payload = {
                    idLoadMore: this.pageSetting.loadMoreLoadingId,
                    container: this.pageSetting.containerName,
                    pagination: this.pagination,
                    callback: this.listPermintaanOutlet,
                };
                await this.$store.dispatch("helper/scroll", payload);
            };
        },
        setScrollPosition() {
            this.pageSetting.loading.list = false;
            setTimeout(() => {
                window.scrollTo(0, this.scrollPosition);
            }, 5);
        },

        // filter
        async doFilter() {
            this.pageSetting.showFilter = false;
            if (this.isSearch && this.searchKey.key.length < 2) {
                return;
            }
            this.pageSetting.loading.list = true;
            this.pageSetting.search.waiting = true;
            await this.$store.commit("permintaanKasOutletModule/resetPagination");
            await this.$store.commit("permintaanKasOutletModule/resetPermintaanKasOutlet");
            await this.listPermintaanOutlet();
        },
        async resetFilter() {
            let temp = this.filter;
            temp.sortBy = "created_at";
            temp.orderBy = "DESC";
            await this.$store.commit("filterGlobalModule/resetFilterItem");
            await this.$store.commit("filterGlobalModule/setFilter", temp);
        },

        // search
        async search() {
            window.scrollTo(0, 0);
            await this.$store.commit("permintaanKasOutletModule/setIsSearch", true);

            this.permintaanOutlet.data.main_data = [];
            this.permintaanOutlet.data.length = 0;
            await this.$store.commit("permintaanKasOutletModule/resetSearch");
            await this.$store.commit("permintaanKasOutletModule/resetInfoTransaksiKonsumen");
            await this.$store.commit("permintaanKasOutletModule/resetPagination");
        },
        loadingSearch(loading) {
            if (!loading) {
                this.permintaanOutlet.data = [];
                this.permintaanOutlet.length = 0;
            }
            this.pageSetting.search.waiting = loading;
            this.pageSetting.loading.list = loading;
        },
        async searchPermintaan(search) {
            await this.$store.commit("permintaanKasOutletModule/resetSearch");
            await this.$store.commit("permintaanKasOutletModule/resetPermintaanKasOutlet");
            await this.$store.commit("permintaanKasOutletModule/resetPagination");

            await this.$store.commit("permintaanKasOutletModule/setSearch", search);
            await this.listPermintaanOutlet();
            this.pageSetting.search.waiting = false;
        },
        async closeSearch() {
            this.pageSetting.loading.list = true;
            // await this.resetFilter()
            await this.$store.commit("permintaanKasOutletModule/setIsSearch", false);

            await this.$store.commit("permintaanKasOutletModule/resetSearch");
            await this.$store.commit("permintaanKasOutletModule/resetPermintaanKasOutlet");
            await this.$store.commit("permintaanKasOutletModule/resetPagination");

            await this.listPermintaanOutlet();
            this.pageSetting.loading.list = false;
        },

        // export
        async checkExport() {
            this.pageSetting.loading.export = false;
            this.pageSetting.minimizedExport = false;
            this.pageSetting.multipleExport = false;
            const res = await this.$store.dispatch("transaksiModule/exportTrack");
            if (!res.success) {
                return;
            }
            this.exportDataLength = res.data.length;
            if (res.data.info_data_export.length > 0) {
                if (res.data.status === 1) {
                    this.pageSetting.multipleExport = true;
                    this.exportData = res.data.info_data_export;
                    this.exportData.forEach((v) => {
                        v["downloaded"] = false;
                    });
                } else {
                    this.pageSetting.minimizedExport = true;
                }
            }
        },
        doExport() {},
        minimizedExport(data) {
            this.pageSetting.loading.export = false;
            this.pageSetting.minimizedExport = true;
            this.exportProgress.processed = Number(data.processed);
            this.exportProgress.total = Number(data.total);
        },

        async flushData() {
            await this.$store.commit("permintaanKasOutletModule/resetPermintaanKasOutlet");
            await this.$store.commit("permintaanKasOutletModule/resetPagination");
            await this.$store.commit("filterGlobalModule/resetFilter");
            await this.$store.commit("permintaanKasOutletModule/resetSearch");
            await this.$store.commit("permintaanKasOutletModule/setIsSearch", false);
        },
    },
};
</script>

<style scoped></style>
